import { replace } from 'connected-react-router';

import _includes from 'lodash/includes';
import _isNumber from 'lodash/isNumber';
import _get from 'lodash/get';

import {
  showTransparentLoader,
  hideLoader,
  setUserData,
  getMeta,
  loadGlobalData,
  hideSnackbar,
  setRowsPerPageOptions,
  setModal,
} from 'containers/store';
import errorCatch from 'utils/errorCatch';
import ApiManager from 'utils/ApiManager';
import PromiseAll from 'utils/PromiseAll';
import getHomeRouteByRole from 'utils/getHomeRouteByRole';
import getRouteByQuery from 'utils/getRouteByQuery';
import createURLWithQuery from 'utils/createURLWithQuery';
import { diagnosticianRoles } from 'utils/constants/rolesOfUsers';
import { LACK_OF_FUND } from 'utils/constants/modalTypes';

import config from 'config';

export const initialState = {
  isMailMessage: false,
  initialValues: {
    login: '',
    password: '',
  },
};

export const actionTypes = {
  SET_MAIL_MESSAGE: 'LOGIN/SET_MAIL_MESSAGE',
  CLEAR_STORE: 'LOGIN/CLEAR_STORE',
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_MAIL_MESSAGE: {
      return {
        ...state,
        isMailMessage: action.mailMessage,
      };
    }

    case actionTypes.CLEAR_STORE: {
      return initialState;
    }

    default:
      return state;
  }
};

const setMailMessage = (mailMessage) => ({
  type: actionTypes.SET_MAIL_MESSAGE,
  mailMessage,
});

const clearStore = () => ({
  type: actionTypes.CLEAR_STORE,
});

export const login = (values) => async (dispatch, getStore) => {
  dispatch(showTransparentLoader());
  dispatch(hideSnackbar());

  const requestBody = {
    data: {
      email: values.login,
      password: values.password,
    },
  };

  try {
    const userData = await ApiManager.request('post', dispatch, 'login', requestBody);

    if (userData === '') {
      dispatch(setMailMessage(true));
      dispatch(hideLoader());
      return;
    }

    localStorage.setItem(config.localStorageLoginKey, JSON.stringify(userData.data.id));

    const data = await PromiseAll({
      meta: dispatch(getMeta()),
      userWithClinics: ApiManager.request('get', dispatch, createURLWithQuery('current_user', { with_clinic: 'clinics' })),
      userWithOrganizations: ApiManager.request('get', dispatch, `users/${userData.data.id}`),
    });

    const hasScaleSelected = _isNumber(userData.data.standard_scale_id);

    const userInfo = {
      ...userData.data,
      clinics: [
        ...data.userWithClinics.data.clinics,
      ],
      organizations: [
        ...data.userWithOrganizations.data.organizations,
      ],
    };

    dispatch(setUserData(userInfo, data.meta.data.userRole));
    dispatch(setRowsPerPageOptions(data.meta));
    dispatch(loadGlobalData());
    dispatch(hideLoader());
    const userRole = userInfo.role_id;
    const transitionalPeriodDaysLeft = _get(userInfo, 'clinics[0].transitional_period_days_left', null);
    const unlimitedUsage = _get(userInfo, 'clinics[0].unlimited_usage', false);
    if (_includes(diagnosticianRoles, userRole) && !userInfo.gdpr_agreed) {
      dispatch(replace('/gdprClause'));
    } else if (_includes(diagnosticianRoles, userRole) && !hasScaleSelected) {
      dispatch(replace('/userProfile', { firstLogin: true }));
    } else {
      const { redirectTo, batteryId } = _get(getStore(), 'router.location.query');
      if (redirectTo) {
        dispatch(replace(...getRouteByQuery(redirectTo, batteryId)));
      } else {
        dispatch(replace(getHomeRouteByRole(userInfo.role_id), { fromLoginPage: true }));
      }

      if (
        _includes(diagnosticianRoles, userRole) && transitionalPeriodDaysLeft && !unlimitedUsage
      ) {
        dispatch(setModal(LACK_OF_FUND));
      }
    }
  } catch (error) {
    const snackbarOptions = {
      showMessageFromApi: true,
      snackbarType: config.snackbarTypes.error,
      snackbarAutohide: false,
    };
    errorCatch(error, dispatch, false, true, snackbarOptions);
  }
};

export const loadPageData = () => (dispatch) => {
  dispatch(clearStore());
};
